import script from "./ReportDashboards.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportDashboards.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__